import { useEffect } from 'react'
import { history } from '../../helpers/history'
import userManager from '../../helpers/UserManager'

const LoginRedirect = () => {
  useEffect(() => {
    const getUser = async () => {
      const user = await userManager.getUserWhenLogin()

      if (user.state && user.state != '/login') {
        history.push(user.state)
      } else {
        history.push('/boatlist')
      }
    }
    getUser().catch(() => {
      userManager.signIn()
    })
  }, [])
  return <></>
}

export default LoginRedirect
